var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00009 9.10523H8.0002C10.4713 9.10523 12.4976 7.26951 12.4976 4.97762C12.4976 2.68583 10.4713 0.85 8.0002 0.85C5.52931 0.85 3.50283 2.68582 3.50283 4.97762L3.50283 4.97774C3.50476 7.26878 5.52995 9.10349 8.00009 9.10523ZM8.00034 1.82416C9.92438 1.82423 11.4607 3.24826 11.4607 4.97762C11.4607 6.70702 9.9243 8.13108 8.0002 8.13108C6.07637 8.13108 4.53974 6.70709 4.53966 4.97776C4.5429 3.24955 6.0777 1.82705 8.00034 1.82416Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.849999 16.6005L0.850001 16.601C0.850871 16.8816 1.09515 17.0868 1.36808 17.0875H1.36847L14.6316 17.0875L14.632 17.0875C14.9052 17.0868 15.1491 16.8816 15.15 16.601V16.6005C15.15 14.7293 14.4076 12.9971 13.054 11.7345C11.7204 10.4868 9.9258 9.79971 8 9.79971C6.07455 9.79971 4.27973 10.4833 2.94606 11.7313C1.59258 12.9972 0.85 14.7258 0.849999 16.6005ZM12.3186 12.4256L12.3187 12.4257C13.3568 13.3946 13.9747 14.6898 14.0882 16.1134H1.90462C2.01838 14.69 2.63933 13.3946 3.67414 12.4256C4.8088 11.3644 6.34462 10.7773 7.99643 10.7773C9.64823 10.7773 11.184 11.3644 12.3186 12.4256Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.271e9489476b162c513e00bf78c41cce.svg";
export { ForwardRef as ReactComponent };